<template>
	<div class="omapi-card__third omapi-campaign-settings__right-column">
		<campaigns-publish
			:changed="changed"
			:saving="saving"
		>
			<campaigns-users-setting :campaignId="campaignId"/>
			<campaigns-status-setting
				:campaignId="id"
				:newStatus="newStatus"
				:statusText="statusText"
				v-on="$listeners"
			/>
		</campaigns-publish>

		<common-card class="omapi-rules-list__wrapper">
			<template v-slot:title>Display Rules Summary</template>
			<campaigns-rule-summary-wrap v-if="! isLegacy" :campaign="campaign"/>
			<p v-else>
				<em>The summary cannot be displayed for legacy campaigns.</em>
			</p>
		</common-card>
	</div>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapGetters } from 'vuex'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign Id
		 */
		campaignId : {
			type : String,
		},
		/**
		 * Campaign status
		 */
		newStatus : {
			type : String,
		},
		/**
		 * Campaign status
		 */
		statusText : {
			type : String,
		},
		changed : Boolean,
		saving  : Boolean,
	},
	computed : {
		...mapGetters('campaigns', [ 'getCampaign' ]),
		/**
		 * Get the campaign object.
		 * @returns {Object} The campaign object.
		 */
		campaign () {
			return this.getCampaign(this.campaignId)
		},

	},
}
</script>
